var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        centerScreen: "",
        bus: _vm.busModal,
        persistent: "",
        centerAndDecreasesPadding: "",
        maxWidth: "45%",
        closeColor: "#8e8e8e",
        backgroundColor: "white"
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: {
                    primary: "",
                    loading: _vm.loading,
                    disabled: _vm.loading || !_vm.canConfirm,
                    "data-test": "confirm-btn"
                  },
                  on: { click: _vm.confirm }
                },
                [_vm._v(" " + _vm._s(_vm.confirmLabel) + " ")]
              )
            ]
          }
        }
      ])
    },
    [
      _c("div", { staticClass: "pb-6" }, [
        _c("div", { staticClass: "modal-title-container" }, [
          _c("span", { staticClass: "modal-title" }, [
            _vm._v(_vm._s(_vm.modalTitle))
          ])
        ]),
        _c(
          "div",
          { staticClass: "modal-content" },
          [
            _c(
              "div",
              { staticClass: "pa-4" },
              [
                _vm.isTransferMode
                  ? _c("input-by-type", {
                      staticClass: "align-icon-search mb-4",
                      staticStyle: { "min-width": "175px" },
                      attrs: {
                        type: "autocomplete",
                        options: _vm.profissionalOptions,
                        labelExternal: "Selecionar profissional",
                        dense: "",
                        "hide-details": "",
                        "data-test": "profissional-select"
                      },
                      model: {
                        value: _vm.selectedProfissional,
                        callback: function($$v) {
                          _vm.selectedProfissional = $$v
                        },
                        expression: "selectedProfissional"
                      }
                    })
                  : _vm._e(),
                _c("input-by-type", {
                  attrs: {
                    type: "textarea-new-ux",
                    labelExternal: _vm.isTransferMode
                      ? "Nota para o profissional (opcional)"
                      : "Motivo da escalada (opcional)",
                    rows: "3",
                    "data-test": "nota-field"
                  },
                  model: {
                    value: _vm.nota,
                    callback: function($$v) {
                      _vm.nota = $$v
                    },
                    expression: "nota"
                  }
                })
              ],
              1
            ),
            _c("v-divider", { staticClass: "my-4" })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }